import axiosClient from './axiosClient';

export const getDriveResultsSummary = () => {
  return axiosClient.get('/admin/results/summary');
};

export const getStudentReview = (driveId, attemptId) => {
  return axiosClient.get(`/admin/drives/${driveId}/results/${attemptId}`);
};

export const getResults = (params) => {
  if (params && params.driveId) {
    const { driveId, ...rest } = params;
    return axiosClient.get(`/admin/drives/${driveId}/results`, { params: rest });
  }
  return axiosClient.get('/admin/results', { params });
};

export const exportResultsExcel = (params) => {
  if (params && params.driveId) {
    const { driveId, ...rest } = params;
    return axiosClient.get(`/admin/drives/${driveId}/results/export/excel`, { params: rest, responseType: 'arraybuffer' });
  }
  return axiosClient.get('/admin/results/export/excel', { params, responseType: 'arraybuffer' });
};


export const deleteStudentResult = (attemptId) => {
  return axiosClient.delete(`/admin/results/${attemptId}`);
};
